import React from "react";

function Avatar({ src, alt, isOnline }) {
  const statusClass = isOnline === true
    ? "is-online"
    : isOnline === false
      ? "is-offline"
      : "";
  return (
    <div className="profile-card__avatar">
      <span className={["avatar-wrapper", statusClass].filter(Boolean).join(" ")}>
        <img src={src} alt={alt} className="profile-card__avatar-img" />
        <span className="avatar-status" aria-hidden="true"></span>
      </span>
    </div>
  );
}

export default Avatar;
